import styled from 'styled-components'

function placeBorder({ $tone }) {
  if ($tone === 'remove') return '#f5c6cb'
  if ($tone === 'add') return '#b7ebc6'
  return '#dadee4'
}

function placeBackground({ $tone }) {
  if ($tone === 'remove') return '#fdecec'
  if ($tone === 'add') return '#e8f8ec'
  return '#f7f8f9'
}

function placeColor({ $tone }) {
  if ($tone === 'remove') return '#b94a48'
  if ($tone === 'add') return '#2f7d4a'
  return 'inherit'
}

export const Item = styled.article`
  border: 1px solid #dadee4;
  border-radius: 0.2rem;
  padding: 0.4rem 0.65rem 0.45rem;
  margin-bottom: 0.4rem;
`

export const Top = styled.div`
  display: flex;
  align-items: flex-start;

  .avatar-md {
    width: 2rem;
    height: 2rem;
    font-size: 1rem;
  }
`

export const Identity = styled.div`
  min-width: 0;
  flex: 1;
  margin-left: 0.5rem;
  line-height: 1.25;
`

export const Meta = styled.div`
  margin-left: 0.75rem;
  text-align: right;
  flex: none;
  white-space: nowrap;
`

export const Bottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 0.3rem;
`

export const Flow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-width: 0;
`

export const PlaceChip = styled.span`
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  border: 1px solid ${placeBorder};
  background: ${placeBackground};
  color: ${placeColor};
  padding: 0.05rem 0.5rem;
  font-size: 0.75rem;
`

export const Arrow = styled.i.attrs({
  className: 'fas fa-arrow-right',
  'aria-hidden': true,
})`
  margin: 0 0.55rem;
  color: ${placeColor};
  font-size: 0.75rem;
`
